import { useQuery } from "@tanstack/react-query";

import { authSession } from "../lib/auth-session";
import { getCurrentUserQueryOptions } from "../queries/current-user-queries";

export function useCurrentUser() {
  const userId = authSession.useCurrentUserId();

  return useQuery(getCurrentUserQueryOptions(userId));
}
